import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IApplicationModel, IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';

export const getPprServiceApplicationList = (data: IDynamicTableParams) => {
  return instance()
    .post<IApplicationModel[]>('/application/ppr/list', data)
    .then((response) => response.data);
};

export const getPprServiceApplicationAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/application/availableColumns')
    .then((response) => response.data);
};

export const getPprServiceApplicationAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/application/availableGroupColumns')
    .then((response) => response.data);
};
